import { VApp } from 'vuetify/lib/components/VApp';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[(_vm.user)?_c('Top',{attrs:{"user":_vm.user,"sioVar":_vm.sioVar}}):_vm._e(),(_vm.user)?_c('Left'):_vm._e(),_c('vue-page-transition',{attrs:{"name":"fade-in-left"}},[_c('router-view',{key:_vm.update_view,staticClass:"router-wrapper"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }